// Gestion du variant picker personnalisé LDS
class LDSVariantPicker {
  constructor() {
    this.init();
  }

  init() {
    // Utilisation de la délégation d'événements pour fonctionner avec le contenu dynamique
    document.addEventListener('mousedown', this.handleMouseDown.bind(this));
    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('variant:update', this.handleVariantUpdate.bind(this));
    
    // Écouter les événements de chargement de contenu dynamique
    document.addEventListener('quickadd:loaded', this.handleDynamicContent.bind(this));
    document.addEventListener('DOMContentLoaded', this.handleDynamicContent.bind(this));
  }

  handleMouseDown(event) {
    const radioInput = event.target.closest('input[type="radio"]');
    if (radioInput && radioInput.closest('.menu-variant-button')) {
      // Mémoriser si le radio était déjà coché avant le clic
      radioInput.dataset.wasChecked = radioInput.checked ? 'true' : 'false';
    }
  }

  handleClick(event) {
    // Gestion du clic sur un radio dans le menu de variants
    const radioInput = event.target.closest('input[type="radio"]');
    if (radioInput && radioInput.closest('.menu-variant-button')) {
      const label = radioInput.closest('label');
      const selectedValue = label ? label.textContent.trim() : radioInput.value;
      const selectSize = radioInput.closest('.select_size');
      const span = selectSize ? selectSize.querySelector('[data-variant-select-button] .truncate') : null;
      const chevron = selectSize ? selectSize.querySelector('[data-chevron-icon]') : null;
      const menu = selectSize ? selectSize.querySelector('.menu-variant-button') : null;

      if (span) span.textContent = selectedValue;
      if (menu) menu.classList.remove('active');
      if (chevron) chevron.classList.remove('turn');

      // Si le radio était déjà coché avant ce clic, forcer l'événement change
      // (le navigateur ne le déclenche pas pour un radio déjà sélectionné)
      if (radioInput.dataset.wasChecked === 'true') {
        setTimeout(() => radioInput.dispatchEvent(new Event('change', { bubbles: true })), 0);
      }
      delete radioInput.dataset.wasChecked;
      return;
    }

    // Gestion du clic sur le bouton de sélection de taille
    if (event.target.closest('[data-variant-select-button]')) {
      event.stopPropagation();

      const button = event.target.closest('[data-variant-select-button]');
      const selectSize = button.closest('.select_size');
      const menu = selectSize.querySelector('.menu-variant-button');
      const chevron = button.querySelector('[data-chevron-icon]');

      if (menu && chevron) {
        menu.classList.toggle('active');
        chevron.classList.toggle('turn');
      }
      return;
    }

    // Fermer tous les menus si on clique ailleurs
    this.closeAllMenus(event);
  }

  closeAllMenus(event) {
    document.querySelectorAll('.menu-variant-button.active').forEach((menu) => {
      if (
        !menu.contains(event.target) &&
        !menu.closest('.select_size').querySelector('[data-variant-select-button]').contains(event.target)
      ) {
        menu.classList.remove('active');
        const chevron = menu.closest('.select_size').querySelector('[data-chevron-icon]');
        if (chevron) chevron.classList.remove('turn');
      }
    });
  }

  handleVariantUpdate(event) {
    // Trouver tous les menus de variants actifs
    document.querySelectorAll('.menu-variant-button').forEach((menu) => {
      const input = menu.querySelector(`input[data-variant-id='${event.detail.resource.id}']`);
      if (input && input.type === 'radio') {
        const label = input.closest('label');
        const selectedValue = label ? label.textContent.trim() : input.value;
        const selectSize = menu.closest('.select_size');
        const span = selectSize.querySelector('[data-variant-select-button] .truncate');
        const chevron = selectSize.querySelector('[data-chevron-icon]');

        if (span) {
          span.textContent = selectedValue;
        }
        menu.classList.remove('active');
        if (chevron) chevron.classList.remove('turn');
      }
    });
  }

  handleDynamicContent() {
    // Initialiser le texte des boutons pour les variants pré-sélectionnés
    document.querySelectorAll('.select_size').forEach((selectSize) => {
      const checkedInput = selectSize.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        const label = checkedInput.closest('label');
        const selectedValue = label ? label.textContent.trim() : checkedInput.value;
        const span = selectSize.querySelector('[data-variant-select-button] .truncate');
        if (span) span.textContent = selectedValue;
      }
    });
  }
}

// Initialiser dès que possible
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new LDSVariantPicker());
} else {
  new LDSVariantPicker();
}